import { motion } from 'framer-motion'
import { X, AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface RoomClosedModalProps {
  isOpen: boolean
  onClose: () => void
}

export default function RoomClosedModal({ isOpen, onClose }: RoomClosedModalProps) {
  const { t } = useTranslation()
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 safe-area">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 20 }}
        className="relative w-full max-w-md card p-6 md:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-xl bg-white/10 hover:bg-white/20 transition-colors"
        >
          <X className="w-5 h-5 text-white/60" />
        </button>

        <div className="text-center mb-6">
          <div className="flex items-center justify-center mb-4">
            <div className="w-14 h-14 bg-red-600 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-7 h-7 text-white" />
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gradient mb-2">{t('roomClosed.title')}</h2>
          <p className="text-white/70">{t('roomClosed.body')}</p>
        </div>

        <div className="space-y-3">
          <button
            onClick={onClose}
            className="btn-primary w-full"
          >
            {t('roomClosed.goHome')}
          </button>
        </div>
      </motion.div>
    </div>
  )
}



